import React, { useState } from 'react';
import TestAnalysisDashboard from './TestAnalysisDashboard';
import AdvancedAnalysisDashboard from './AdvancedAnalysisDashboard';
import IndividualStudentAnalysis from './IndividualStudentAnalysis';
import IPEAnalysisDashboard from './IPEAnalysisDashboard';
import TTestAnalysisDashboard from './TTestAnalysisDashboard';
import './App.css';

function App() {
  const [activeDashboard, setActiveDashboard] = useState('basic');
  
  const navStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0',
    backgroundColor: '#e5e7eb',
    borderBottom: '1px solid #d1d5db',
    fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
  };
  
  const navButtonStyle = {
    padding: '10px 20px',
    margin: '0 10px',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontWeight: '500',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
  };
  
  const activeButtonStyle = {
    ...navButtonStyle,
    backgroundColor: '#3b82f6',
    color: 'white',
    borderColor: '#2563eb'
  };
  
  return (
    <div className="App">
      <div style={navStyle}>
        <button 
          style={activeDashboard === 'basic' ? activeButtonStyle : navButtonStyle}
          onClick={() => setActiveDashboard('basic')}
        >
          Test Performance Dashboard
        </button>
        <button 
          style={activeDashboard === 'advanced' ? activeButtonStyle : navButtonStyle}
          onClick={() => setActiveDashboard('advanced')}
        >
          Advanced Analysis Dashboard
        </button>
        <button 
          style={activeDashboard === 'individual' ? activeButtonStyle : navButtonStyle}
          onClick={() => setActiveDashboard('individual')}
        >
          Individual Student Analysis
        </button>
        <button 
          style={activeDashboard === 'ipe' ? activeButtonStyle : navButtonStyle}
          onClick={() => setActiveDashboard('ipe')}
        >
          IPE Analysis Dashboard
        </button>
        <button 
          style={activeDashboard === 'ttest' ? activeButtonStyle : navButtonStyle}
          onClick={() => setActiveDashboard('ttest')}
        >
          T-Test Analysis
        </button>
      </div>
      
      {activeDashboard === 'basic' && <TestAnalysisDashboard />}
      {activeDashboard === 'advanced' && <AdvancedAnalysisDashboard />}
      {activeDashboard === 'individual' && <IndividualStudentAnalysis />}
      {activeDashboard === 'ipe' && <IPEAnalysisDashboard />}
      {activeDashboard === 'ttest' && <TTestAnalysisDashboard />}
    </div>
  );
}

export default App;